import { webApi } from "../../../../core/http/httpThunks";
import { PayType } from "../types";

export const getAllPayTypeApi = (userId: string) =>
  webApi<PayType[]>({
    method: "GET",
    url: "listing/getpaytypelist",
    params: {
      userId,
    },
  });

export default getAllPayTypeApi;
